/**
 * All three substitutions in one alternation so a string is scanned once
 * instead of three times. This is safe because no substitution can produce
 * text that a later one would have matched: `Red\xA0Bull` contains no
 * backslash escape, and the `\r`/`\n` control characters can't form
 * `Red Bull`.
 *
 * The pattern is declared twice: the non-global variant answers the cheap
 * "does this string need anything at all?" question (it carries no `lastIndex`
 * state, so reusing a single instance is safe), and the global one does the
 * actual rewrite on the few strings that match.
 */
const REPLACEMENTS_TEST = /Red Bull|RED BULL|\\r|\\n/;
const REPLACEMENTS_GLOBAL = /Red Bull|RED BULL|\\r|\\n/g;

function replacement(match: string) {
  if (match === "\\r") return "\r";
  if (match === "\\n") return "\n";
  return "Red\xA0Bull";
}

export function replaceRedBullWhitespaces(input: string) {
  // Returning the *same* string reference when nothing matches is what lets
  // `processStoryContent` share unchanged subtrees instead of copying them.
  if (!REPLACEMENTS_TEST.test(input)) {
    return input;
  }

  return input.replace(REPLACEMENTS_GLOBAL, replacement);
}
